module.exports = __webpack_public_path__ + "static/media/service2.a6e5cb20.png";